/* Fransk katalog for locale-payroll-delivery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'err.payslip.notAuthorized': 'Vous n\'avez pas accès à cette demande d\'envoi.',
  'err.payslip.approvedRunRequired': 'Approuvez le cycle de paie avant de mettre les bulletins de paie en file d\'attente.',
  'err.payslip.queueTooLarge': 'Les données des bulletins de paie sont trop volumineuses pour être mises en file d\'attente. Contactez le support.',
  'pay.payslipSent': 'Bulletin de paie envoyé.',
  'pay.payslipsSent': 'Bulletins de paie envoyés.',
  'pay.payslipsSentAndPosted': 'Bulletins de paie envoyés et paie comptabilisée.',
  'pay.payslipsQueuedAndPosted': 'Paie comptabilisée. Bulletins de paie mis en file d\'envoi.',
  'pay.payslipQueued': 'En file d\'envoi',
  'pay.payslipsQueued': 'Bulletins de paie en file d\'envoi.',
  'pay.payslipGenerated': 'Généré',
  'pay.payslipNotReady': 'Pas prêt',
  'pay.payslipScheduled': 'Planifié',
});
